import * as React from 'react';
import { withRouter } from 'react-router';
import { push, replace as routerReplace, go, goBack as routerGoBack } from 'connected-react-router';

export const types = {
  GO_TO: 'app/navigation/GO_TO',
  SET_HISTORY: 'app/navigation/SET_HISTORY',
  REACT_ROUTER_INIT: '@@INIT',
  REACT_ROUTER_LOCATION_CHANGE: '@@router/LOCATION_CHANGE',
};


function savePageState(newState) {
  // store.dispatch((dispatch, getState) => {
  //   const state = getState();
  //   const currentHistory = selectors.getHistory(state);
  //   const currentPage = currentHistory.pop();
  //   currentPage.state = newState;
  //
  //   currentHistory.push(currentPage);
  //   store.dispatch(navigationSetHistory(currentHistory));
  // });
  return routerReplace(window.location.pathname, newState);
}

function goTo(pathname, pushState) {
  return push(pathname, pushState);
}

function goBackTo(desiredPathname, desiredPageState = {}, pagesToSkip = []) {
  return routerReplace(desiredPathname);
  // const state = getState();

  // const currentHistory = selectors.getHistory(state);
  // let goBackCount = 0;
  // let foundPage = false;
  // const matchPageState = Object.keys(desiredPageState).length > 0;

  // while (currentHistory.length > 0) {
  //   const page = currentHistory.pop();
  //   goBackCount--;
  //   if (page.pathname === desiredPathname) {
  //     foundPage = matchPageState ? JSON.stringify(page.state) === JSON.stringify(desiredPageState) : true;

  //     const matches = pagesToSkip.filter((p) => {
  //       if (p.pathname && p.pathname === page.pathname) {
  //         return true;
  //       } else if (p.state && JSON.stringify(p.state) === JSON.stringify(page.state)) {
  //         return true;
  //       } else {
  //         return false;
  //       }
  //     });

  //     if (matches.length === 0 && foundPage) {
  //       currentHistory.push(page);
  //       goBackCount++;
  //       break;
  //     }
  //   }

  //   foundPage = false;
  // }

  // if (foundPage) {
  //   return go(goBackCount);
  // } else {
  //   return push(desiredPathname, desiredPageState);
  // }
}

function goBack(defaultPathname, defaultPageState, pagesToSkip = []) {
  return routerGoBack(defaultPathname);
  // const state = getState();
  // const currentHistory = selectors.getHistory(state);
  // currentHistory.pop();
  // let goBackCount = -1;

  // if (pagesToSkip.length > 0) {
  //   while (currentHistory.length > 0) {
  //     const page = currentHistory[currentHistory.length - 1];
  //     const matches = pagesToSkip.filter((p) => {
  //       if (p.pathname && p.pathname === page.pathname) {
  //         return true;
  //       } else if (p.state && JSON.stringify(p.state) === JSON.stringify(page.state)) {
  //         return true;
  //       } else {
  //         return false;
  //       }
  //     });

  //     if (matches.length === 0) {
  //       currentHistory.push(page);
  //       break;
  //     }

  //     goBackCount--;
  //   }
  // }

  // if (currentHistory.length > 0) {
  //   dispatch(go(goBackCount));
  // } else if (defaultPathname && defaultPathname.indexOf('http') >= 0) {
  //   window.location = defaultPathname;
  // } else if (defaultPathname) {
  //   dispatch(push(defaultPathname));
  // } else {
  //   dispatch(push('/'));
  // }
}

function replace(pathname, pageState) {
  return routerReplace(pathname, pageState);
}

const actions = {
  goBack,
  goTo,
  goBackTo,
  replace,
  savePageState,
  // navigationSetHistory,
  // navigationGoTo,
};

let store = null;

export const SetupGlobalNav = withRouter(class extends React.Component {
  constructor(props) {
    super(props);
    store = props.store;
  }

  render() {
    return this.props.children;
  }
});

export function navigate(pathname) {
  store.dispatch(goTo(pathname));
}

export function navigateBack(pathname) {
  store.dispatch(goBackTo(pathname));
}

export default actions;
